/**
 * Update DOM elements with Ajax results
 *
 * @param {number} quantity - quantity
 * @param {string} selector - DOM element to look up in the tile's qty element
 * @return {undefined}
 */
 function updateTile(quantity, selector) {
    $(selector).empty().html(quantity);
    var unitQuantity = $('.unit').html();
    if (quantity && quantity > 0) {
        if(unitQuantity && unitQuantity.trim() == 'kg') {
            var roundedPrice = (Math.round((quantity)*10000)/10000).toString().replace('.', ',');
            $(selector).empty().html(roundedPrice);
        }
        $(selector).closest('.add-to-cart').find('.tile-add-to-cart').removeClass('show');
        $(selector).closest('.add-to-cart').find('.update-quantity').addClass('show');
    } else {
        $(selector).closest('.add-to-cart').find('.tile-add-to-cart').addClass('show');
        $(selector).closest('.add-to-cart').find('.update-quantity').removeClass('show');
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function updateQuantities() {
    var items = $('.cart-json').data('cart'); // Products presents in basket at render time from Controller -> DOM
    $('.add-to-cart').find('.tile-add-to-cart').addClass('show');
    $('.add-to-cart').find('.update-quantity').removeClass('show');
    if (items && items.itemsquantities && items.itemsquantities.length > 0) {
        items.itemsquantities.forEach((item) => {
            var variableWeight = $(`.itemquantity-${item.id} .quantity`).closest('.add-to-cart').data('variable-weight');
            if (variableWeight) {
                updateTile(Math.round((item.qty * item.unitValue)*10000)/10000, `.itemquantity-${item.id} .quantity`);
            } else {
                updateTile(item.qty, `.itemquantity-${item.id} .quantity`);
            }
        });
    }
}

/**
 * Refresh tiles quantities showed in suggestions navbar-search
 *
 * @return {undefined} - DOM manipulation
 */
function updateSuggestionsQuantities() {
    var productsInSuggestions = $('.suggestions .product');

    if (productsInSuggestions.length > 0) {
        var items = $('.cart-json').data('cart');
        var cartItemsMap = {};
        var pageQuantitiesMap = {}; // Mapa para almacenar las cantidades de los productos en la página

        var productsOnPage = $('.product-grid .product, .product-detail, .experience-einstein .product, .experience-einstein-einsteinCarouselCategoryMM .product').filter(function() {
            return $(this).closest('.suggestions').length === 0;
        });

        productsOnPage.each(function() {
            var $product = $(this);
            var pid = $product.data('pid');
            var $itemQuantity = $product.find('.itemquantity-' + pid + ' .quantity');
            var $updateQuantity = $itemQuantity.closest('.update-quantity'); // Obtener el ancestro .update-quantity
        
            if ($updateQuantity.length > 0 && $updateQuantity.css('display') !== 'none') {
                var quantity = parseInt($itemQuantity.text(), 10);
                if (!isNaN(quantity)) {
                    pageQuantitiesMap[pid] = quantity; // Almacenar la cantidad de la página
                }
            }
        });

        if (items && items.itemsquantities && items.itemsquantities.length > 0) {
            items.itemsquantities.forEach(function(item) {
                cartItemsMap[item.id] = item.qty;
            });
        }

        productsInSuggestions.each(function() {
            var $product = $(this);
            var pid = $product.data('pid');
            var $itemQuantity = $product.find('.itemquantity-' + pid + ' .quantity');
            var selector = '.itemquantity-' + pid + ' .quantity';
            var quantityOnPage = pageQuantitiesMap[pid];
            var quantityInCart = cartItemsMap[pid];

            if ($(selector, $product).length > 0) {
                // Producto presente en suggestions
                if (quantityOnPage !== undefined) {
                    if (quantityOnPage > 0) {
                        // Usar cantidad de la página si es mayor que cero
                        updateTile(quantityOnPage, selector);
                    }
                } else if (quantityInCart !== undefined) {
                    // Si quantityOnPage es undefined, usar la cantidad del carrito
                    updateTile(quantityInCart, selector);
                }
            }
        });
    }
}

/**
 * Refresh tiles quantities showed in front
 *
 * @return {undefined} - DOM manipulation
 */
function updateQuantitiesRecommender() {
    var items = $('.cart-json').data('cart'); // Productos en el carrito desde el Controller -> DOM

    if (items && items.itemsquantities && items.itemsquantities.length > 0) {
        items.itemsquantities.forEach(function(item) {
            // Seleccionar solo los elementos dentro de los recomendadores
            $('.experience-einstein, .experience-einstein-einsteinCarouselCategoryMM')
                .find(`.itemquantity-${item.id} .quantity`)
                .each(function() {
                    var $quantityElement = $(this);
                    var variableWeight = $quantityElement.closest('.add-to-cart').data('variable-weight');

                    if (variableWeight) {
                        updateTile(Math.round((item.qty * item.unitValue) * 10000) / 10000, $quantityElement);
                    } else {
                        updateTile(item.qty, $quantityElement);
                    }
                });
        });
    }
}

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    return $($el).closest('.add-to-cart').data('pid');
}

/**
 * Retrieves url to use when adding a product to the cart
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl($el) {
    return $($el).closest('.add-to-cart').data('endpoint-add-to-cart');
}

/**
 * Retrieves url to use when adding a product to the cart
 * @param {jquery} $el - DOM container for a given change qty button
 * @return {string} - The provided URL to use when changing quantity
 */
function getUpdateQuantityUrl($el) {
    return $($el).closest('.add-to-cart').data('endpoint-update-quantity');
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    const $html = $('<div>').append($.parseHTML(html));

    const body = $html.find('.choice-of-bonus-product');
    const footer = $html.find('.modal-footer').children();

    return { body, footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    let bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    const htmlString = `${'<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="'}${data.maxBonusItems}"`
        + `data-UUID="${data.uuid}"`
        + `data-pliUUID="${data.pliUUID}"`
        + `data-addToCartUrl="${data.addToCartUrl}"`
        + 'data-pageStart="0"'
        + `data-pageSize="${data.pageSize}"`
        + `data-moreURL="${data.showProductsUrlRuleBased}"`
        + `data-bonusChoiceRuleBased="${data.bonusChoiceRuleBased}">`
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + `    <span class="">${data.labels.selectprods}</span>`
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success(response) {
            const parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error() {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 * @param {jquery} el - DOM container for a given add to cart button
 */
function handlePostCartAdd(response, el) {
    $('.minicart').trigger('count:update', response);
    if (response && response.cart && response.cart.items) {
        const pid = el.closest('.add-to-cart').data('pid');
        const products = response.cart.items.filter((item) => item.id === pid);
        if (products && products.length > 0) {
            var product = products.pop();
            el.closest('.add-to-cart').find('.update-quantity').addClass('show');
            if (product.variableWeight) {
                el.closest('.add-to-cart').find('.update-quantity .quantity').html((Math.round(product.unitData.value *100)/100).toString().replace('.', ','));
            } else {
                el.closest('.add-to-cart').find('.update-quantity .quantity').html('1');
            }
            el.removeClass('show');

            // Buscar y actualizar tiles duplicadas
            $('.product[data-pid="' + pid + '"]').each(function() {
                const $otherTile = $(this);
                if (!$otherTile.is(el.closest('.product'))) { // Evitar actualizar la tile original
                    $otherTile.find('.add-to-cart').find('.update-quantity').addClass('show');
                    if (product.variableWeight) {
                        $otherTile.find('.add-to-cart').find('.update-quantity .quantity').html((Math.round(product.unitData.value * 100) / 100).toString().replace('.', ','));
                    } else {
                        $otherTile.find('.add-to-cart').find('.update-quantity .quantity').html('1');
                    }
                    $otherTile.find('.add-to-cart').find('.tile-add-to-cart').removeClass('show');
                }
            });

            // Buscar y actualizar la PDP
            $('.product-detail[data-pid="' + pid + '"]').each(function () {
                const $pdp = $(this);
                $pdp.find('.product-details .add-to-cart .update-quantity').addClass('show');
                if (product.variableWeight) {
                    $pdp.find('.detailsPDP .add-to-cart .update-quantity .quantity').html((Math.round(product.unitData.value * 100) / 100).toString().replace('.', ','));
                    $pdp.find('.sticky-add-to-cart .add-to-cart .update-quantity .quantity').html((Math.round(product.unitData.value * 100) / 100).toString().replace('.', ','));
                } else {
                    $pdp.find('.detailsPDP .add-to-cart .update-quantity .quantity').html('1');
                    $pdp.find('.sticky-add-to-cart .add-to-cart .update-quantity .quantity').html('1');
                }
                $pdp.find('.detailsPDP .add-to-cart .tile-add-to-cart').removeClass('show');
                $pdp.find('sticky-add-to-cart .add-to-cart .tile-add-to-cart').removeClass('show');
            });
        }
    }

    const messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append('<div class="add-to-cart-messages"></div>');
        }

        $('.add-to-cart-messages').append(`<div class="alert ${messageType} add-to-basket-alert text-center" role="alert">${
            response.message
        }</div>`);

        setTimeout(() => {
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the quantity change button
 * @param {jquery} el - DOM container for a given quantity change button
 */
function updateQuantity(response, el) {
    if (response && response.items && response.items) {
        let product;
        const pid = el.closest('.add-to-cart').data('pid');
        const products = response.items.filter((item) => item.id === pid);
        if (products && products.length > 0) {
            product = products.pop();
            if (product.variableWeight) {
                var unitQuantity = $('.unit').html();
                if(unitQuantity && unitQuantity.trim() == 'kg') {
                    var roundedPrice = (Math.round((product.quantity * product.unitData.value)*1000)/1000).toString().replace('.', ',');
                    el.closest('.add-to-cart').find('.update-quantity .quantity').html(roundedPrice);
                } else {
                    el.closest('.add-to-cart').find('.update-quantity .quantity').html(roundedPrice);
                }
            } else {
                el.closest('.add-to-cart').find('.update-quantity .quantity').html((Math.round(product.quantity*100)/100).toString().replace('.', ','));
            }
        }
    }
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url,
            method: 'GET',
            success() {
                // reporting urls hit on the server
            },
            error() {
                // no reporting urls hit on the server
            }
        });
    }
}

/**
 * Makes a CSRF-token research in the twolineheader element to fill the product-notes-form
 * Deletes the previous csrf_token if already exists
 * @param {Element} div - principal div in notes form
 */
function fillCSRFToken(modalForm) {
    var csrfTokenName = $('#customerConnectTk input[type="hidden"]').attr('name');
    var csrfTokenValue = $('#customerConnectTk input[type="hidden"]').val();

    if (csrfTokenName && csrfTokenValue) {
        // Search and deletes previous input (to ignore possible cached elements)
        modalForm.find('input[name="' + csrfTokenName + '"]').remove();
        // Creates new input element
        var csrfInput = $('<input>', {
            type: 'hidden',
            name: csrfTokenName,
            value: csrfTokenValue
        });
        // Append new input element
        modalForm.find('.modal-body').append(csrfInput);
    }
}

/**
 * Manages the display of promotion tooltips on product tiles.
 * - Toggles tooltip visibility on click of '.tile-promotions'.
 * - Closes tooltip on click outside.
 * - Prevents navigation of main tile links when its tooltip is visible.
 */
function showPromotions() {
    const tilePromotionsSelector = '.tile-promotions';
    const promotionDateSelector = 'div.promotiondate';
    const visibleClass = 'is-visible';
    const tileActiveClass = 'js-promotion-active';

    $(document).on('click', tilePromotionsSelector, function (event) {
        const $trigger = $(this);
        const $tooltip = $trigger.find(promotionDateSelector);
        const isCurrentTooltipVisible = $tooltip.hasClass(visibleClass);
            const isAutoPromo = !!$tooltip.data('autoPromoActive');

        // Caso 1: Clic en un enlace DENTRO de un tooltip YA VISIBLE -> Permite la navegación del enlace dentro del tooltip.
        if (isCurrentTooltipVisible && $(event.target).closest(promotionDateSelector).length > 0 && ($(event.target).is('a') || $(event.target).closest('a').length > 0)) {
            return; // No hacer nada más, permitir la acción por defecto del enlace.
        }

        // Caso 2: Clic en el ÁREA DEL TRIGGER de un tooltip YA VISIBLE -> El objetivo es simplemente CERRAR este tooltip.
        if (isCurrentTooltipVisible) {
            $tooltip.removeClass(visibleClass);
            $trigger.removeClass(tileActiveClass);
                $tooltip.removeData('autoPromoActive');
            // Limpiamos el timeout si se cierra manualmente
            const hideTimeoutId = $tooltip.data('hideTimeout');
            if (hideTimeoutId) {
                clearTimeout(hideTimeoutId);
            }
            event.stopPropagation();
            return;
        }

        // Caso 3: Clic en un trigger cuyo tooltip está CERRADO (o clic en un trigger diferente mientras otro está abierto).
        // El objetivo es abrir este tooltip y cerrar cualquier otro que esté abierto.
        if ($(event.target).closest(promotionDateSelector).length === 0 && ($(event.target).is('a') || $(event.target).closest('a', $trigger).length > 0)) {
            event.preventDefault();
        }

        // Cerrar todos los OTROS tooltips que puedan estar abiertos.
        $(tilePromotionsSelector).not($trigger).each(function () {
            $(this).removeClass(tileActiveClass);
            $(this).find(promotionDateSelector).removeClass(visibleClass);
        });

        $tooltip.addClass(visibleClass);
        $trigger.addClass(tileActiveClass);

        // Ocultar con timeout
        // Nueva lógica: solo ocultar cuando el mouse sale del tooltip
        const clearHideTimeout = () => {
            const hideTimeoutId = $tooltip.data('hideTimeout');
            if (hideTimeoutId) {
                clearTimeout(hideTimeoutId);
                $tooltip.removeData('hideTimeout');
            }
        };

        $tooltip.off('mouseenter.promo').on('mouseenter.promo', function () {
            clearHideTimeout();
        });
        $tooltip.off('mouseleave.promo').on('mouseleave.promo', function () {
            clearHideTimeout();
            const hideTimeoutId = setTimeout(() => {
                $tooltip.removeClass(visibleClass);
                $trigger.removeClass(tileActiveClass);
            }, 4000);
            $tooltip.data('hideTimeout', hideTimeoutId);
        });

        // Si el mouse ya no está encima, iniciar el timeout
        if (!$tooltip.is(':hover')) {
            const hideTimeoutId = setTimeout(() => {
                $tooltip.removeClass(visibleClass);
                $trigger.removeClass(tileActiveClass);
            }, 4000);
            $tooltip.data('hideTimeout', hideTimeoutId);
        }

        event.stopPropagation();
    });

    // Event listener for clicks on the document to close active tooltips
    $(document).on('click', function (event) {
        const $target = $(event.target);
        // Si el click es fuera de la promo, solo cerrar si no está activa por autoshow
        $(tilePromotionsSelector + '.' + tileActiveClass).each(function () {
            const $tooltip = $(this).find(promotionDateSelector);
            if (!$tooltip.data('autoPromoActive')) {
                $(this).removeClass(tileActiveClass);
                const hideTimeoutId = $tooltip.data('hideTimeout');
                if (hideTimeoutId) {
                    clearTimeout(hideTimeoutId);
                }
                $tooltip.removeClass(visibleClass);
            }
        });
    });

    // Event listener to prevent navigation from main product tile links when its promotion tooltip is active
    $(document).on('click', '.product-tile a', function (event) {
        const $link = $(this);
        const $tile = $link.closest('.product-tile'); // Assuming '.product-tile' is the main container
        const $tooltip = $tile.find(tilePromotionsSelector).find(promotionDateSelector);

        // If the tooltip for this tile is visible AND the clicked link is NOT inside the tooltip itself
        if ($tooltip.hasClass(visibleClass) && $link.closest(promotionDateSelector).length === 0) {
            event.preventDefault();
        }
    });
}

/**
 * Automatically displays the promotion tooltip when a product tile with a promotion becomes visible in the viewport (e.g. while scrolling).
 * This function uses the IntersectionObserver API to detect when a `.tile-promotions` element enters the visible area of the screen.
 * Once triggered, the promotion tooltip is shown by adding the `is-visible` and `js-promotion-active` classes, and is automatically hidden after 3 seconds.
 * The observer unobserves each element after its first appearance to avoid re-triggering the animation repeatedly.
 * This enhances the user experience by proactively surfacing promotions without requiring manual interaction (like clicking).
 */
function autoShowPromotionsOnView() {
    const tileSelector = '.tile-promotions';
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
    };

    // Guardar el observer en window para poder reutilizarlo
    if (!window._promotionTileObserver) {
        window._promotionTileObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const $tile = $(entry.target);
                    const $tooltip = $tile.find('div.promotiondate');
                    if (!$tooltip.hasClass('is-visible')) {
                        $tooltip.addClass('is-visible');
                        $tile.addClass('js-promotion-active');
                            $tooltip.data('autoPromoActive', true);
                        const timeoutId = setTimeout(() => {
                            $tooltip.removeClass('is-visible');
                            $tile.removeClass('js-promotion-active');
                                $tooltip.removeData('autoPromoActive');
                        }, 4000);
                        $tooltip.data('hideTimeout', timeoutId);
                    }
                }
            });
        }, observerOptions);
    }
    const observer = window._promotionTileObserver;

    // Observar solo los tiles que no han sido observados aún
    document.querySelectorAll(tileSelector).forEach(el => {
        if (!el._promotionObserved) {
            observer.observe(el);
            el._promotionObserved = true;
        }
    });

    // MutationObserver para observar nuevas tiles agregadas dinámicamente
    if (!window._promotionTileMutationObserver) {
        // Busca el contenedor principal de tiles (ajusta el selector si es necesario)
        const gridContainer = document.querySelector('.product-grid') || document.body;
        window._promotionTileMutationObserver = new MutationObserver(function(mutationsList) {
            mutationsList.forEach(mutation => {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1) { // Elemento
                            // Si el nodo es una tile-promotions, observarla
                            if (node.matches && node.matches(tileSelector)) {
                                if (!node._promotionObserved) {
                                    observer.observe(node);
                                    node._promotionObserved = true;
                                }
                            }
                            // Si el nodo contiene tiles, observarlas
                            node.querySelectorAll && node.querySelectorAll(tileSelector).forEach(el => {
                                if (!el._promotionObserved) {
                                    observer.observe(el);
                                    el._promotionObserved = true;
                                }
                            });
                        }
                    });
                }
            });
        });
        window._promotionTileMutationObserver.observe(gridContainer, { childList: true, subtree: true });
    }
}

$(document).ready(function () {
    // Nodos a observar
    const targetNodes = [
        $('.experience-einstein-einsteinCarouselCategoryMM')[0], // Home
        $('.experience-einstein')[0], // PLP, PDP, WISHLIST, etc.
        // ...Array.from(document.querySelectorAll('[id^="cq_recomm_slot-"]')) //account, cart
    ].filter(Boolean);

    let modifiedNodes = new Set();

    const observer = new MutationObserver(function (mutationsList, observer) {
        mutationsList.forEach(mutation => {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                let targetNode = mutation.target;

                if (!modifiedNodes.has(targetNode)) {
                    modifiedNodes.add(targetNode);

                    // Añadir la clase de animación al contenedor del recomendador
                    // Animación solo si el targetNode NO está dentro de un div con id="homepage"
                    if ($(targetNode).closest('#homepage').length === 0) {
                        $(targetNode).addClass('recommender-loaded-animate');
                    }

                    updateQuantitiesRecommender();
                    autoShowPromotionsOnView();

                }
            }
        });

        // Todos los nodos han sido modificados, desconectar
        if (modifiedNodes.size === targetNodes.length) {
            observer.disconnect();
        }
    });

    // Desconectar después de 10 segundos si no se han modificado todos los nodos (error de carga)
    const timeout = setTimeout(() => {
        observer.disconnect();
    }, 2000);

    // Iniciar observación general de los nodos
    targetNodes.forEach(targetNode => {
        observer.observe(targetNode, { childList: true, subtree: true });
    });
});

module.exports = {
    addToCart() {
        $(document).on('click', 'button.tile-add-to-cart', function (event) {
            event.stopPropagation();
            event.preventDefault();
            const el = $(this);

            $('body').trigger('product:beforeAddToCart', this);

            const pid = getPidValue($(this));

            let $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
            }

            const addToCartUrl = getAddToCartUrl(el);

            const form = {
                pid,
                quantity: 0
            };

            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success(data) {
                        handlePostCartAdd(data, el);
                        $('body').trigger('product:afterAddToCart', data);
                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);
                    },
                    error() {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    updateQuantityCart() {
        $(document).on('click', 'button.tile-update-quantity', function (event) {
            event.stopPropagation();
            event.preventDefault();
            const el = $(this);

            $('body').trigger('product:beforeAddToCart', this);

            const pid = getPidValue($(this));
            const updateQuantityUrl = getUpdateQuantityUrl($(this));
            const decrease = $(this).data('decrease');

            let $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
            }

            const form = {
                pid,
                decrease,
                quantity: 1
            };

            $(this).trigger('updateAddToCartFormData', form);
            if (updateQuantityUrl) {
                $.ajax({
                    url: updateQuantityUrl,
                    method: 'GET',
                    data: form,
                    success(data) {
                        $('.minicart').trigger('count:update', data);
                        $('body').trigger('product:afterAddToCart', data);
                        $('.minicart .minicart-quantity .text').text(data.quantityTotal);
                        var prodsQuantity = 0;
                        if (data && data.basket && data.basket.items) {
                            const id = el.closest('.add-to-cart').data('pid');
                            const products = data.basket.items.filter((item) => item.id === id);
                            if (products.length === 0) {
                                // Veficar que esta en detailsPDP para ver si va con el sticky, para modificar los dos
                                const isInDetailsPDP = el.closest('.detailsPDP').length > 0;

                                if (isInDetailsPDP) {
                                    // Modificamos los dos elementos .add-to-cart dentro de .detailsPDP que serían el propio de la PDP y el sticky
                                    $('.detailsPDP .add-to-cart').each(function () {
                                        const buttonContainer = $(this);

                                        buttonContainer.find('.update-quantity').removeClass('show');
                                        buttonContainer.find('.tile-add-to-cart').addClass('show');
                                    });
                                } else {
                                    // Modifica el boton .add-to-cart donde se hizo clic
                                    el.closest('.add-to-cart').find('.update-quantity').removeClass('show');
                                    el.closest('.add-to-cart').find('.tile-add-to-cart').addClass('show');

                                    // Buscar y actualizar otras tiles con el mismo data-pid
                                    const pid = el.closest('.add-to-cart').data('pid');
                                    $('.product[data-pid="' + pid + '"]').each(function() {
                                        const $otherTile = $(this);
                                        if (!$otherTile.is(el.closest('.product'))) { // Evitar actualizar la tile original
                                            $otherTile.find('.add-to-cart').find('.update-quantity').removeClass('show');
                                            $otherTile.find('.add-to-cart').find('.tile-add-to-cart').addClass('show');
                                        }
                                    });

                                    // Buscar y actualizar la PDP
                                    $('.product-detail[data-pid="' + pid + '"]').each(function () {
                                        const $pdp = $(this);
                                        $pdp.find('.add-to-cart .update-quantity').removeClass('show');
                                        $pdp.find('.add-to-cart .tile-add-to-cart').addClass('show');
                                    });
                                }
                            }

                            const items = data.basket.items;

                            for (var i = 0; i < items.length; i++) {
                                if (items[i].unitData && items[i].unitData.unit === 'kg') {
                                    prodsQuantity++;
                                } else {
                                    prodsQuantity += items[i].quantity;
                                }
                            }
                            $('.minicart .minicart-quantity .text').text(prodsQuantity.toString().replace('.', ','));
                        } else if (data && data.items) {

                            const addToCartButtons = $('.add-to-cart');

                            // Modificamos los dos elementos .add-to-cart (normal y sticky) presentes en la PDP
                            addToCartButtons.each(function () {
                                const buttonContainer = $(this);

                                updateQuantity(data, buttonContainer);
                            });


                            const items = data.items;

                            for (var i = 0; i < items.length; i++) {
                                if (items[i].unitData && items[i].unitData.unit === 'kg') {
                                    prodsQuantity++;
                                } else {
                                    prodsQuantity += items[i].quantity;
                                }
                            }
                            $('.minicart .minicart-quantity .text').text(prodsQuantity.toString().replace('.', ','));
                        }
                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);
                    },
                    error() {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    updateMinicart() {
        $('body').on('cart:update', () => {
            updateQuantities();
        });
    },
    notesModalModalEvent() {
        $('.product-grid').on('shown.bs.modal', '.modal.center-modal-product-notes', function () {
            fillCSRFToken($(this));
        });
            
    },
    updateQuantities: updateQuantities,
    updateSuggestionsQuantities: updateSuggestionsQuantities,
    initializePromotions: function () {
        showPromotions();
        autoShowPromotionsOnView()
    }
};
